export default __webpack_public_path__ + "static/media/mapLocation.a1be75eb.svg";